const Attach = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill="#393188"
      d="M13.848 12.83a.833.833 0 0 1 1.178 1.178l-2.652 2.652a5.834 5.834 0 1 1-8.25-8.25L8.84 3.697a4.167 4.167 0 1 1 5.892 5.891l-4.713 4.715a2.5 2.5 0 1 1-3.536-3.535l3.83-3.83a.833.833 0 1 1 1.179 1.178l-3.831 3.83a.833.833 0 1 0 1.18 1.178l4.713-4.714a2.5 2.5 0 1 0-3.536-3.535L5.303 9.59a4.167 4.167 0 1 0 5.893 5.892l2.652-2.65Z"
    />
  </svg>
);
export default Attach;
